import { render, staticRenderFns } from "./ArtistProfileMedia.vue?vue&type=template&id=71f47f28&scoped=true"
import script from "./ArtistProfileMedia.vue?vue&type=script&lang=js"
export * from "./ArtistProfileMedia.vue?vue&type=script&lang=js"
import style0 from "./ArtistProfileMedia.vue?vue&type=style&index=0&id=71f47f28&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71f47f28",
  null
  
)

export default component.exports